import { render, staticRenderFns } from "./_4.vue?vue&type=template&id=5b027505&scoped=true&"
import script from "./_4.vue?vue&type=script&lang=js&"
export * from "./_4.vue?vue&type=script&lang=js&"
import style0 from "./_4.vue?vue&type=style&index=0&id=5b027505&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b027505",
  null
  
)

export default component.exports